import { Box, IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";
import UploadIcon from "@mui/icons-material/Upload";

export default function TimelineControls({ onAdd, onOpenJsonDialog, disabled }: any) {
    return (
        <Box mb={2} textAlign="right">
            <IconButton onClick={onAdd} color="primary" disabled={disabled}>
                <Add />
            </IconButton>
            <IconButton onClick={onOpenJsonDialog} color="secondary" title="Import JSON">
                <UploadIcon />
            </IconButton>
        </Box>
    );
}
